export default __webpack_public_path__ + "static/media/icon_ihmiset_aloitettu.36f804bf.svg";